/**
 * @class
 * @memberOf P3.utils
 */
export default class ObjectPool {
    /**
     * @param {*} t
     * @param {number} size
     * @param {Array} args
     */
    constructor(t, size, args) {
        /**
         * @member {*}
         * @protected
         */
        this._t = t;

        /**
         * @type {Array}
         * @private
         */
        this._args = args || [];

        /**
         * @member {Array.<*>}
         * @protected
         */
        this._free = [];

        /**
         * @member {Array.<*>}
         * @protected
         */
        this._used = [];

        this.expand(Math.max(1, size));
    }

    /**
     */
    destroy() {
        for (let i = 0; i < this._free.length; ++ i) {
            const object = this._free[i];
            (object && object.destroy) && object.destroy();
        }
        this._free.length = 0;

        for (let i = 0; i < this._used.length; ++ i) {
            const object = this._used[i];
            (object && object.destroy) && object.destroy();
        }
        this._used.length = 0;
    }

    /**
     * @param {number} size
     */
    expand(size) {
        for (let i = 0; i < size; ++ i) {
            const object = Object.create(this._t.prototype);
            object.constructor = this._t;
            this._t.apply(object, this._args);
            this._free.push(object);
        }
    }

    /**
     * @returns {*}
     */
    create() {
        const object = this._free.shift();
        if (!object) return null;

        this._used.push(object);
        return object;
    }

    /**
     * @param {*} obj
     * @returns {boolean}
     */
    free(obj) {
        const index = this._used.indexOf(obj);
        if (index !== -1) {
            obj.reset && obj.reset();
            this._free.push(obj);
            this._used.splice(index, 1);
        }
        return index !== -1;
    }

    /**
     * @returns {*}
     */
    get baseClass() {
        return this._t;
    }

    /**
     * @returns {number}
     */
    get size() {
        return this._free.length + this._used.length;
    }

    /**
     * @returns {number}
     */
    get available() {
        return this._free.length;
    }
}